// extracted by mini-css-extract-plugin
export var compactTypeRampUpdates = "oH2W7";
export var firstLineMultiColumnTypeRamp = "pRyEG";
export var firstLineMultilineColumnTypeRamp = "WKV4l";
export var full = "Ejrkd";
export var fullTypeRampUpdates = "K3Sti";
export var medium = "U2XB8";
export var mediumTypeRampUpdates = "L9Agk";
export var messageListMajorTextNext = "gy2aJ";
export var messageListMinorTextNext = "_rWRU";